/**
 * Notification Sound Service
 * Handles playing notification sounds and managing sound preferences
 */

class NotificationSoundService {
  private soundEnabled: boolean = true;
  private audioContext: AudioContext | null = null;
  private soundBuffer: AudioBuffer | null = null;

  constructor() {
    // Load sound preference from localStorage
    const savedPreference = localStorage.getItem('notificationSoundEnabled');
    this.soundEnabled = savedPreference ? JSON.parse(savedPreference) : true;
    
    this.initializeAudio();
  }

  private async initializeAudio() {
    try {
      this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
      // You can load a custom notification sound here
      // For now, we'll use the default browser notification sound
    } catch (error) {
      console.warn('Audio context not supported:', error);
    }
  }

  public isEnabled(): boolean {
    return this.soundEnabled;
  }

  public toggle(enabled?: boolean): void {
    this.soundEnabled = enabled !== undefined ? enabled : !this.soundEnabled;
    localStorage.setItem('notificationSoundEnabled', JSON.stringify(this.soundEnabled));
  }

  public play(): void {
    if (!this.soundEnabled) return;

    try {
      // For browser compatibility, we'll use a simple approach
      // You can replace this with a custom audio file
      const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmEcCCiL0fPTgjEGIHC+7+OZTRA!');
      audio.volume = 0.3;
      audio.play().catch(() => {
        // Silently fail if audio can't be played
      });
    } catch (error) {
      console.warn('Could not play notification sound:', error);
    }
  }

  public async playCustomSound(audioUrl: string): Promise<void> {
    if (!this.soundEnabled) return;

    try {
      const audio = new Audio(audioUrl);
      audio.volume = 0.5;
      await audio.play();
    } catch (error) {
      console.warn('Could not play custom notification sound:', error);
      // Fallback to default sound
      this.play();
    }
  }
}

// Export singleton instance
export const notificationSound = new NotificationSoundService();
export default notificationSound;
